import { MarketingCenteredText } from "../../components/MarketingCenteredTextBlock";
import { MarketingFooter } from "../../components/MarketingFooter";
import { MarketingMenu } from "../../components/MarketingMenu";
import { MarketingOGTags } from "../../components/MarketingOGTags";
import { GenericGridDesktop, MarketingTextSVGHeader } from "../../components/MarketingTextSVGHeader";
import { FadeUpContainer } from "../../components/ReusableStyledComponents/FadeUp";
import { MarketingInlineLink } from "../../components/ReusableStyledComponents/MarketingLink";
import { MarketingUL } from "../../components/ReusableStyledComponents/MarketingUl";
import { VerticalSpacing } from "../../components/VerticalSpacing";
import { theme } from "../../theme/theme";
import { APPLICATION_ROUTES } from "../../shared-logic/routes";

export const TOSPageLayout = () => {
    return (
        <>
            <MarketingOGTags
                title="Authory – Learn more about our terms and conditions"
                description="This document informs you about the terms for the service that Authory provides."
                canonicalUrl={`${process.env.NEXT_PUBLIC_FRONTEND_URL}${APPLICATION_ROUTES.TERMS}`}
            />
            <MarketingMenu />
            <FadeUpContainer>
                <VerticalSpacing top={20} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: 50 }]}>
                    <MarketingTextSVGHeader
                        title={<>Terms of Service</>}
                        desktopSVG={<GenericGridDesktop />}
                        mobileSVG={<></>}
                        textMaxWidth={750}
                        containerMaxWidth={1320}
                        textMarginTop={50}
                    />
                </VerticalSpacing>
                <VerticalSpacing top={30} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: -90 }]}>
                    <MarketingCenteredText
                        title={""}
                        punchline={<>General Provisions</>}
                        description={
                            <>
                                <p>
                                    We only conclude contracts with entrepreneurs in the sense of § 14 German Civil Code (An entrepreneur means a
                                    natural or legal person or a partnership with legal personality who or which, when entering into a legal
                                    transaction, acts in exercise of his or its trade, business or profession). We do not accept the application of
                                    consumers to open an account.
                                </p>
                                <p>
                                    Deviating, conflicting or supplementary general terms and conditions of the customer, even with our knowledge, are
                                    not part of the contract, unless their validity is expressly agreed.
                                </p>
                            </>
                        }
                    />
                </VerticalSpacing>
                <VerticalSpacing top={60}>
                    <MarketingCenteredText
                        title={""}
                        punchline={<>Account</>}
                        description={
                            <>
                                <p>
                                    You must be of legal age to create an account. When you create an account with us, you must provide us the
                                    requested information which needs to be accurate, complete, and current at all times. Failure to do so constitutes
                                    a breach of the Terms, which may result in immediate termination of your account on our Service.
                                </p>
                                <p>For your account you have to choose a name which does not violate any laws or third-party rights.</p>
                                <p>
                                    We are free to reject your application for opening account without stating any reasons. Your account becomes
                                    active once it is approved by us. This can take place by way of separate declaration or activation of the account.
                                </p>
                                <p>You must notify us immediately upon becoming aware of any security or unauthorized use of your account.</p>
                            </>
                        }
                    />
                </VerticalSpacing>
                <VerticalSpacing top={60}>
                    <MarketingCenteredText
                        title={""}
                        punchline={<>Content, Transfer of Rights</>}
                        description={
                            <>
                                <p>
                                    You are responsible for the content that you do post on authory.com, let us have posted on authory.com, send or
                                    let us sent to authory´s users, including its legality, reliability, and appropriateness.
                                </p>
                                <p>
                                    By posting or letting us post content on authory.com you grant us the right and license to use, publicly perform,
                                    publicly display, reproduce, and distribute this content as required to perform our services as agreed with you.
                                </p>
                                <p>
                                    You especially agree that this license includes the right for us to make your content available in the extent
                                    agreed with you to other users of authory.com.
                                </p>
                                <p>
                                    You represent and warrant that the content and the ways by which you make it accessible does not violate the laws,
                                    privacy rights, publicity rights, copyrights, contract rights or any other rights of any third party.
                                </p>
                            </>
                        }
                    />
                </VerticalSpacing>
                <VerticalSpacing top={60}>
                    <MarketingCenteredText
                        title={""}
                        punchline={<>Forbidden Content</>}
                        description={
                            <>
                                <p>It is not permitted to post the following content to authory.com or its users</p>
                                <MarketingUL>
                                    <li>which is pornographic in nature</li>
                                    <li>
                                        which violates law for the protection of children and young persons, data protection laws and/or any other
                                        applicable laws and/or which is of fraudulent nature:
                                    </li>
                                    <li>utilization of content that is offensive or slanderous to third parties;</li>
                                    <li>
                                        which is of offensive, objectionable, sexually explicit, obscene or defamatory or which is likely to promote
                                        or support racism, fanaticism, hatred, physical violence or illegal activities (either implicit or explicit);
                                    </li>
                                </MarketingUL>
                                <p>
                                    It is on our sole discretion to remove or block access to content which we consider in violation of our terms of
                                    service.
                                </p>
                            </>
                        }
                    />
                </VerticalSpacing>
                <VerticalSpacing top={60}>
                    <MarketingCenteredText
                        title={""}
                        punchline={<>Liability</>}
                        description={
                            <>
                                <p>
                                    In the case of simply negligent breach of essential contractual obligations, our liability is limited in amount to
                                    the foreseeable and contractually typical damages. Essential contractual obligations are those whose fulfillment
                                    makes the proper execution of the contract possible in the first place and on whose observance the customer may
                                    regularly rely. The limitation period is one year. This paragraph does not apply in the case of injury to life,
                                    limb or health, for claims arising from product liability, if we are guilty of malicious action or the assumption
                                    of a guarantee.
                                </p>
                            </>
                        }
                    />
                </VerticalSpacing>
                <VerticalSpacing top={60}>
                    <MarketingCenteredText
                        title={""}
                        punchline={<>Indemnification</>}
                        description={
                            <>
                                <p>
                                    You shall hold us harmless from any liability vis-a-vis third parties that derive from your violation of legal
                                    regulations, against the rights of third parties (in particular against privacy rights, copyrights or trademark
                                    rights) or against contractual obligations, warranties or promises, including the costs incurred for necessary
                                    legal defence (lawyer and court costs).
                                </p>
                                <p>
                                    You are obliged, in case of asserting such a claim to immediately and fully participate in establishing the facts
                                    of the matter and to provide us with the necessary information in an appropriate manner.
                                </p>
                            </>
                        }
                    />
                </VerticalSpacing>
                <VerticalSpacing top={60}>
                    <MarketingCenteredText
                        title={""}
                        punchline={<>Term and Termination</>}
                        description={
                            <>
                                <p>Each party can terminate this agreement to the end of the paid term or the trial period by giving notice.</p>
                                <p>
                                    In addition each party can termination this agreement for good cause without prior notice. Good cause includes but
                                    is not limited to the following:
                                </p>
                                <p>
                                    a) the continuing breach by the offending party of contractual obligations that are fundamental to the proper
                                    performance of the contract, whose violation jeopardises its entire purpose and which the other party may
                                    regularly rely on being complied with, unless the offending Party remedies the breach after receiving a written
                                    warning setting a reasonable deadline;
                                </p>
                                <p>
                                    b) if a petition is filed for the opening of insolvency proceedings; the rejection of such a petition due to lack
                                    of assets and the opening of insolvency proceedings;
                                </p>
                                <p>c) if the other Party ceases trading;</p>
                            </>
                        }
                    />
                </VerticalSpacing>
                <VerticalSpacing top={60}>
                    <MarketingCenteredText
                        title={""}
                        punchline={<>Miscellaneous</>}
                        description={
                            <>
                                <p>
                                    This Agreement represents the entire understanding between the parties concerning its subject matter. Any
                                    conflicting ancillary agreements and prior agreements on the contractual subject matter are herewith rendered
                                    void.
                                </p>
                                <p>
                                    If a provision of this Agreement is or becomes wholly or partially void, invalid or non-enforceable, or a
                                    necessary provision is not contained in the Agreement, the validity and enforceability of all other provisions of
                                    this Agreement will not be affected.
                                </p>
                                <p>The Agreement is governed exclusively by the law of the Federal Republic of Germany.</p>
                                <p>International private law does not apply unless mandatory.</p>
                                <p>The sole place of jurisdiction for all disputes in connection with this Agreement is Hamburg, Germany.</p>
                            </>
                        }
                    />
                </VerticalSpacing>
                <VerticalSpacing top={60}>
                    <MarketingCenteredText
                        title={""}
                        punchline={<>Commissioned Data Processing Contract</>}
                        description={
                            <>
                                <p>
                                    You agree that you are the the data controller ("Controller") and that Authory is the data processor
                                    ("Processor").
                                </p>
                                <p>
                                    1) The Controller is commissioning the data processing by the Processor on the basis of a contractual agreement
                                    governing the use of authory.com (the "Main Contract"). The Processor manages the email addresses of the
                                    Controller's subscribers and sends them emails on behalf of the Controller.
                                </p>
                                <p>
                                    2) The Processor shall process the personal data only on documented instructions from the Controller, including
                                    the transfer of personal data to a third country or an international organisation, unless he is obliged to do so
                                    by the law of the European Union or of the Member States to which the Processor is subject, in which case the
                                    Processor shall notify the Controller of these legal requirements prior to processing, unless the law concerned
                                    prohibits such notification because of an important public interest.
                                </p>
                                <p>
                                    3) If the Processor is of the opinion that an instruction of the Controller violates the GDPR or other data
                                    protection provisions of the European Union or of the Member States, it shall inform the Controller immediately.
                                </p>
                                <p>
                                    4) The Controller undertakes to take all necessary measures to ensure the security of the processing in accordance
                                    with Art. 32 GDPR. He will only commission the processing of personal data by such persons who have undertaken to
                                    maintain confidentiality in accordance with the provisions of the GDPR or who are subject to an appropriate
                                    statutory duty of confidentiality.
                                </p>
                                <p>
                                    5) If possible, the Processor shall support the Controller with suitable technical and organisational measures to
                                    meet his obligation to respond to requests for the exercise of the rights of the person concerned specified in
                                    Chapter 3 of the GDPR. The Controller will assist the Processor in complying with the obligations set out in
                                    Articles 32 to 36 DSGVO, taking into account the nature of the processing and the information available to him.
                                </p>
                                <p>
                                    6) Upon completion of the processing services, the Processor shall, at the choice of the Controller, either delete
                                    or return all personal data and delete the existing copies, unless there is an obligation to store the personal
                                    data under European Union law or the law of the Member States. The corresponding services shall be appropriately
                                    remunerated by the Controller on a time and material basis.
                                </p>
                                <p>
                                    7) The Processor shall provide the Controller with all the information necessary to demonstrate compliance with
                                    the obligations set out in this Clause and, against reasonable remuneration for his efforts, shall enable and
                                    con-tribute to reviews, including inspections, to be carried out by the Controller or any other auditor appointed
                                    by the Controller.
                                </p>
                                <p>
                                    8) The Processor will engage the subcontractors published on this website (
                                    <MarketingInlineLink target="_blank" href="http://www.authory.com/privacy/subcontractors">
                                        authory.com/privacy/subcontractors
                                    </MarketingInlineLink>
                                    ) in performance of this Agreement. He is entitled to call in further subcontractors or to replace existing
                                    subcontractors, provided that the requirements of paragraph 2 and 4 of Art. 28 GDPR are met for these
                                    subcontractors. He will publish the corresponding intention on the aforementioned website. If the Controller does
                                    not object within four weeks after publication, the Processor is entitled to the appropriate implementation.
                                </p>
                                <p>
                                    9) In the event of a violation of the protection of personal data, the Processor shall notify the Controller
                                    immediately and if possible within 48 hours of becoming aware of the violation. He will provide him with all
                                    information and, if necessary, perform all necessary actions so that the Controller can fulfill his obligations
                                    under Art. 33 GDPR. Duration of the Contract, Termination of the Contract, Right of Retention
                                </p>
                                <p>
                                    10) The term of this contract shall be determined by the term of the Main Contract in accordance with Section 1.
                                </p>
                            </>
                        }
                    />
                </VerticalSpacing>
                <VerticalSpacing top={120} breakpoints={[{ screen: theme.breakpoints.tablet, marginTop: 180 }]}>
                    <MarketingFooter />
                </VerticalSpacing>
            </FadeUpContainer>
        </>
    );
};
